/**
 * Checks if a prescription is expired based on its issue date and the current date.
 * A prescription is considered expired if it is older than the specified valid time in months.
 * @param issueDate - The issue date of the prescription in the format "MM/YYYY" or ISO date string
 * @param actualDay - The current date to compare against the issue date
 * @param validTimeInMonth - The number of months a prescription is valid for (default is 24 months)
 * @returns true if the prescription is expired, false otherwise
 */
export const isExpiredPrescription = (
  issueDate: string,
  actualDay: Date = new Date(),
  validTimeInMonth: number = 24,
) => {
  if (!validTimeInMonth) throw new Error(`Valid time not setted`);
  
  let issueMonth: number;
  let issueYear: number;

  // Check if the date is in ISO format or MM/YYYY format
  if (issueDate.includes('T') || issueDate.includes('-')) {
    // ISO date format
    const date = new Date(issueDate);
    issueMonth = date.getMonth() + 1; // getMonth() returns 0-11
    issueYear = date.getFullYear();
  } else {
    // MM/YYYY format
    issueMonth = Number(issueDate.split("/")[0]);
    issueYear = Number(issueDate.split("/")[1]);
  }

  const actualMonth = actualDay.getMonth() + 1;
  const actualYear = actualDay.getFullYear();

  return (
    issueMonth + issueYear * 12 <
    actualMonth + actualYear * 12 - validTimeInMonth
  );
};
